<template>
  <div v-if="canUse('set-default-data-source').valid && dataSourceList.length">
    <div class="text-sm px-2.5 opacity-70 text-white">数据源默认值</div>
    <div
      v-for="(item, index) in dataSourceList"
      :key="'datasourceDefaultValue' + index"
      class="my-1"
    >
      <AttrSelect
        :label="item?.label"
        :value="curDefaultValue"
        :options="item?.options"
        :width="item?.key === 'dateLunarYear' ? 200 : 100"
        @change="(val:string)=> setValue('dateYear',val)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useDataSource } from '@/hooks';
import { useDataSourceStore } from '@/store/use-data-source-store';
import { computed } from 'vue';
import { canUse } from '@/utils/can-use.utils';
import { useRuntimeStore } from '@/store/use-runtime-store';
import dayjs from 'dayjs';
import { Solar } from 'lunar-javascript';
import { sexagenaryCycleArr } from '@/resources/data-source';

const runtimeStore = useRuntimeStore();
const dataSourceStore = useDataSourceStore();

const dataSourceList = computed(() => {
  const curUseDatasource = runtimeStore.configData;
  const _year = dayjs().year();
  const years = [_year, _year + 1, _year + 2, _year + 3];
  const wholeList = [
    {
      label: '年份',
      key: 'dateYear',
      options: years.map((year) => {
        return { label: year.toString(), value: year.toString() };
      })
    },
    {
      label: '农历年',
      key: 'dateLunarYear',
      options: years.map((year) => {
        return { label: year.toString(), value: year.toString() };
      })
    },
    {
      label: '天干地支',
      key: 'dateSexagenaryCycle',
      options: years.map((year) => {
        const lunar = Solar.fromYmd(year, 5, 1).getLunar();
        const ganzhi = lunar.getYearInGanZhi();
        const index = sexagenaryCycleArr.findIndex((item) => item == ganzhi);
        const label = sexagenaryCycleArr[index];
        return { label: index + '（' + label + '）', value: year };
      })
    },
    {
      label: '天干地支字符串',
      key: 'dateLunarStringYear',
      options: years.map((year) => {
        const lunar = Solar.fromYmd(year, 5, 1).getLunar();
        const ganzhi = lunar.getYearInGanZhi();
        const index = sexagenaryCycleArr.findIndex((item) => item == ganzhi);
        const label = sexagenaryCycleArr[index];
        return { label: label, value: year };
      })
    }
  ];
  return wholeList.filter((i) => curUseDatasource[i.key] !== undefined);
});

const curDefaultValue = computed(() => dataSourceStore.data.dateYear ?? '2024');
const { reset } = useDataSource();

const setValue = (dataSource: string, value: string) => {
  dataSourceStore.setValue(dataSource, Number(value));
  reset();
};
</script>

<style scoped></style>
